'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/with-stages.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _reduxWindow = require('redux-window');
var _formInfo = require('@marmalade/form/lib/selectors/form-info');
var _progressBar = require('@marmalade/progress-bar');
var _progressBar2 = _interopRequireDefault(_progressBar);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var stateToProps = function stateToProps(state, _ref) {
  var newBusinessStages = _ref.newBusinessStages;
  return {
    stages: newBusinessStages.map(function (stage) {
      return Object.assign({}, stage, {
        complete: (0, _formInfo.isValidAndPristine)(state, stage.formId)
      });
    }),
    withNames: (0, _reduxWindow.getWidth)(state) > 767
  };
};
WithStages.propTypes = {
  newBusinessStages: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    formId: _propTypes.string.isRequired
  })).isRequired
};
function WithStages(props) {
  var Component = (0, _reactRedux.connect)(stateToProps)(_progressBar2.default);
  return _react2.default.createElement(Component, Object.assign({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22
    },
    __self: this
  }));
}
exports.default = WithStages;